import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { RecoilRoot } from "recoil";
import ReactDOM from "react-dom/client";
import "./index.css"; // Import your global CSS file
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "mdb-react-ui-kit/dist/css/mdb.min.css"; // Import MDB React UI Kit CSS
import "@fortawesome/fontawesome-free/css/all.min.css"; // Import Font Awesome CSS

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

// Create a root for concurrent mode rendering (React 18+)
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render your application inside the root
root.render(
  <QueryClientProvider client={queryClient}>
  <RecoilRoot>
    {/* <React.StrictMode> */}
      <App />
    {/* </React.StrictMode> */}
  </RecoilRoot>

  </QueryClientProvider>
);

// Measure performance metrics of your app
reportWebVitals();
